import { t } from "i18next";

import { useDeleteMassInvoiceMutation } from "../../services/bankingService";

import toast from "react-hot-toast";
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";
import { useToasts } from "../../hooks/useToasts";

import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import Button from "@mui/material/Button";

import { centerVericalAlignIconStyle } from "../../helpers/styles";
import ConfirmationDialog from "../../components/dialog/ConfirmationDialog/confirmationDialog";
import { useDialogBetter } from "../../hooks/useDialogBetter";

export function DeleteMassInvoiceButton(props) {
    const { onFormErrors, onServerError } = useToasts();
    const { mutate: deleteInvoices } = useDeleteMassInvoiceMutation({
            onSuccess: () => {
                toast.custom(
                    () => <SnackbarSuccess message={t("successfullyDeleted")} />,
                    {
                        position: "bottom-right",
                    },
                );
                props.onSubmit?.()
            },
            onError: (error) => {
                onServerError(error);
            },
        });

    const {
          openDialog: openConfirmationDialog,
          closeDialog: closeConfirmationDialog,
      } = useDialogBetter();
  
    const handleOpenConfirmationDialog =()=> openConfirmationDialog({
        Component: ConfirmationDialog,
            componentProps: {
            title: t("bankings.confirmDeleteInvoices"),
            onYes: () => {
                closeConfirmationDialog()
                deleteInvoices({invoice_ids: props.selectedInvoices})
            },
            onNo: () => {
                closeConfirmationDialog()
            },
            showCancelButton: false,
            },
        })

  const handleDeleteInvoices = () => {
    if (props.selectedInvoices?.length === 0) return;

    handleOpenConfirmationDialog()
  };


  return (
        <Button
            fullWidth
            variant="contained"
            size="small"
            color="error"
            startIcon={
                <RemoveCircleOutlineOutlinedIcon sx={centerVericalAlignIconStyle} />
            }
            onClick={handleDeleteInvoices}
        >
            {t("bankings.delete_invoices")}
        </Button>
  );
}